const { NumberFormatters } = require('./NumberFormatters')
const shortenNumber = NumberFormatters.methods.shortenNumber

export default {
  data() {
    return {
      toolTipContent: null,
    }
  },

  methods: {
    getTrendLineContent(itemData) {
      let sections = []
      if (itemData['amount'] != undefined) {
        const amount = itemData['amount']
        const fixedAmount = amount % 1 != 0 ? amount.toFixed(2) : amount
        const shortAmount = shortenNumber(fixedAmount, this.useCurrency)

        sections.push(shortAmount)

        if (this.reportDataType === 'visits') {
          sections.push(shortAmount == 1 ? 'visit' : this.reportDataType)
        }
      }

      if (itemData['date_time']) {
        const dateWords = itemData['date_time'].split(' ')
        sections.push(`${dateWords[0]}`)

        let hourSpanString = `@ ${dateWords[1]}`

        const currentIndex = this.graphData.findIndex(data => { return data.date_time === itemData['date_time']})
        const onLastIndex = this.graphData.length === currentIndex + 1

        if (!onLastIndex ) {
          hourSpanString += ' - ' + this.graphData[currentIndex + 1]['date_time'].split(' ')[1]
        } else if (itemData['final_end_time']) {
          hourSpanString += ' - ' + itemData['final_end_time'].split(' ')[1]
        }

        sections.push(hourSpanString)
      }

      return sections
    },

    getRecipientContent(itemData) {
      let sections = []

      if (itemData['recipient'] != undefined && itemData['nonrecipient'] != undefined) {
        const recipient = shortenNumber(itemData['recipient'], this.useCurrency)
        const nonrecipient = shortenNumber(itemData['nonrecipient'], this.useCurrency)
        sections.push(recipient, 'vs', nonrecipient)
      }

      if (itemData['date_time']) {
        const dateWords = itemData['date_time'].split(' ')
        sections.push(`${dateWords[0]}`, `@ ${dateWords[1]}`)
      }

      return sections
    },

    getToolTipContent(itemData, graphType) {
      let content = [];
      switch (graphType) {
        case 'recipients':
          content = this.getRecipientContent(itemData)
          break;
        case 'trends':
          content = this.getTrendLineContent(itemData)
          break;
      }
      return content;
    },
  },
}